import Filter from "./Filter";
import TotalBox from "./TotalBox";

export default {
  Filter,
  TotalBox,
};
